import type { Palette } from '@mui/material'

/**
 * THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
 * Generated from /networks/berachain/darkPalette.json
 */
const TEMPLATE_PALETTE = {
  primary: {
    dark: '#d99611',
    main: '#FDB72D',
    light: '#A1A3A7',
  },
  secondary: {
    dark: '#636669',
    main: '#FFFFFF',
    light: '#FDB72D',
    background: '#2a261b',
  },
  logo: {
    main: '#F9F4D5',
    background: '#303033',
  },
  background: {
    default: '#131312',
    main: '#131312',
    paper: '#1C1C1C',
    light: '#2a231b',
    lightGrey: '#303033',
  },
} as Partial<Palette>
export default TEMPLATE_PALETTE
